<template>
  <vue-pdf-app :pdf="pdfURL"></vue-pdf-app>
</template>

<script>
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  components: {
    VuePdfApp
  },
  data() {
    return {
      pdfURL: ""
    }
  },
  mounted() {
    this.pdfURL = this.$route.query.linkUrl
  }
};
</script>